import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import Overlay from 'components/Overlay';
import Style from './MVPDStartOverlay.module.scss';

export default class MVPDStart extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      authenticationStarted,
      rendered: prevRendered,
      tealiumAuthenticationStarted,
      tvProviderFeatListViewed,
    } = this.props;
    const { rendered: currentRendered } = nextProps;
    if (!prevRendered && currentRendered) {
      tvProviderFeatListViewed();
      authenticationStarted();
      tealiumAuthenticationStarted();
    }
  }

  render() {
    const {
      backgroundUrl,
      children,
      innerContainerChildren,
      rendered,
      backgroundClass,
      innerContainerChildrenParams,
      sharedTheme,
    } = this.props;
    return (
      <Overlay
        backgroundClass={backgroundClass}
        backgroundUrl={backgroundUrl}
        sharedTheme={sharedTheme}
        theme={Style}
        rendered={rendered}
        innerContainerChildren={innerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
      >
        {children}
      </Overlay>
    );
  }
}

MVPDStart.defaultProps = {
  authenticationStarted: noop,
  backgroundClass: '',
  backgroundUrl: null,
  children: {},
  innerContainerChildren: noop,
  innerContainerChildrenParams: {},
  rendered: false,
  sharedTheme: {},
  tealiumAuthenticationStarted: () => {},
  tvProviderFeatListViewed: noop,
};

MVPDStart.propTypes = {
  authenticationStarted: PropTypes.func,
  backgroundClass: PropTypes.string,
  backgroundUrl: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  innerContainerChildren: PropTypes.func,
  innerContainerChildrenParams: PropTypes.shape({}),
  rendered: PropTypes.bool,
  sharedTheme: PropTypes.shape({}),
  tealiumAuthenticationStarted: PropTypes.func,
  tvProviderFeatListViewed: PropTypes.func,
};
